import { createMarkup } from '@packages/domain/utils/createMarkup/createMarkup';
import { useTranslations } from 'utils';

export const AstropayConditions = () => {
  const i18n = useTranslations();
  return (
    <>
      <span
        dangerouslySetInnerHTML={createMarkup(
          i18n.t('termsAndConditions.partners.astropay'),
        )}
      />
    </>
  );
};

AstropayConditions.displayName = 'AstropayConditions';
